"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allFormRulesetsSelector = void 0;
exports.metadataSelector = metadataSelector;
const selectors_1 = require("../modules/selectors");
const composure_1 = require("@icg360/composure");
const noMetadata = {};
function metadataSelector(state, props) {
    const { id, index } = (0, selectors_1.useFormOrCurrent)(state, props);
    if (state.rex.version[id] > 1) {
        return (0, composure_1.selectFormMeta)(id);
    }
    return state.rex.forms[id][index].metadata || noMetadata;
}
const noRulesets = {};
const allFormRulesetsSelector = (state, props) => {
    const { id, index } = (0, selectors_1.useFormOrCurrent)(state, props);
    if (state.rex.version[id] > 1) {
        return state.rex.composure[id]?.rulesets || noRulesets;
    }
    const form = state.rex.forms[id];
    if (form) {
        return form[index].rulesets || noRulesets;
    }
    return noRulesets;
};
exports.allFormRulesetsSelector = allFormRulesetsSelector;
//# sourceMappingURL=selectors.js.map